import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-line bg-graphite" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-6">
          <img src="/ogk-logo.png" alt="OGK logo" className="w-10 h-10 object-contain" />
          <span className="font-heading font-semibold text-white uppercase tracking-wide text-sm">OGK Infra & Developers</span>
        </div>
        <p className="text-silver text-sm leading-relaxed max-w-xs">
          Building the foundations of tomorrow — residential, commercial, industrial and infrastructure projects delivered with engineering precision since 2008.
        </p>
      </div>

      <div>
        <h4 className="text-white font-heading uppercase tracking-widest text-sm mb-6">Services</h4>
        <ul className="space-y-3 text-sm text-silver">
          {[["Residential Construction", "residential-construction"], ["Commercial Construction", "commercial-construction"], ["Roads & Infrastructure", "roads-infrastructure"], ["Turnkey Construction", "turnkey-construction"], ["Project Management", "project-management"]].map(([label, slug]) => (
            <li key={slug}><Link to={`/services/${slug}`} className="hover:text-ember transition-colors duration-200">{label}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-white font-heading uppercase tracking-widest text-sm mb-6">Company</h4>
        <ul className="space-y-3 text-sm text-silver">
          <li><Link to="/about" className="hover:text-ember transition-colors duration-200">About Us</Link></li>
          <li><Link to="/projects" className="hover:text-ember transition-colors duration-200">Projects</Link></li>
          <li><Link to="/gallery" className="hover:text-ember transition-colors duration-200">Gallery</Link></li>
          <li><Link to="/blog" className="hover:text-ember transition-colors duration-200">Insights</Link></li>
          <li><Link to="/careers" className="hover:text-ember transition-colors duration-200">Careers</Link></li>
          <li><Link to="/track" className="hover:text-ember transition-colors duration-200">Track Your Project</Link></li>
          <li><Link to="/book-site-visit" className="hover:text-ember transition-colors duration-200">Book a Site Visit</Link></li>
          <li><Link to="/login" className="hover:text-ember transition-colors duration-200">ERP Login</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-heading uppercase tracking-widest text-sm mb-6">Head Office</h4>
        <ul className="space-y-4 text-sm text-silver">
          <li className="flex gap-3"><MapPin size={16} className="text-ember shrink-0 mt-0.5" /> Malom, Near Oil Depot, Imphal, Manipur 795140</li>
          <li className="flex gap-3"><Phone size={16} className="text-ember shrink-0 mt-0.5" /> +91 70059 73358</li>
          <li className="flex gap-3"><Mail size={16} className="text-ember shrink-0 mt-0.5" /> ogkinfra@gmail.com</li>
        </ul>
        <Link to="/request-quote" data-testid="footer-quote-btn"
          className="inline-flex items-center gap-2 mt-8 text-ember uppercase text-xs tracking-[0.2em] font-bold hover:gap-3 transition-[gap] duration-200">
          Start a Project <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
    <div className="border-t border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-silver/70 uppercase tracking-widest">
        <span>© 2026 OGK Infra & Developers. All rights reserved.</span>
        <span>ISO 9001 · ISO 45001 · Class-A Contractor</span>
      </div>
    </div>
  </footer>
);
